import { useGetEducationalVideoList } from '@viome/viome-base/src/usecase/Education/EducationQuery';

export const useGetEducationSeriesVideoList = ({
  screen,
}: {
  screen: string;
}) => {
  const {
    data: educarouselData,
    isLoading: isEducarouselLoading,
    isError: isEducarouselError,
  } = useGetEducationalVideoList(screen);

  return {
    educarouselData,
    isEducarouselLoading,
    isEducarouselError,
  };
};
